module.exports = __webpack_public_path__ + "static/media/aliza.bbf64a8f.png";